import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from "typeorm";
import { PaperMergeEntity } from "./paper-merge.entity";

@Entity("paper_merge_child")
export class PaperMergeChildEntity {
    @PrimaryGeneratedColumn({ type: "int", name: "id" })
    id: number;

    @Column("int",{name:"paperId"})
    paperId: number;

    @Column("int",{name:"partId"})
    partId: number;

    @Column("int",{name:"mainModelPaperId"})
    mainModelPaperId: number;

    @ManyToOne(() => PaperMergeEntity, (paperMerge) => paperMerge.paperMergeChild)
    @JoinColumn({ name: 'paper_merge_id' })
    paperMergeId: PaperMergeEntity
}